import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview"]

  preview() {
    const file = this.inputTarget.files[0]
    if (!file) return

    const reader = new FileReader()
    reader.onload = (e) => {
      this.previewTarget.innerHTML = `
        <img src="${e.target.result}"
             class="w-24 h-24 rounded-full object-cover"
             alt="Aperçu" />
      `
    }
    reader.readAsDataURL(file)
  }
}
